import React, { useState } from "react";
import { Row, Col } from "react-bootstrap";
import { getIn, useFormikContext } from "formik";
import LField from "components/Inputs/LField";
import CreditCard from "./CreditCard";
import LSelect from "components/Inputs/LSelect";
import { EBrand, identifyBrand } from "../service/efi.service";
import { useLandingPageContext } from "pages/Context/LandinPageContext";
import LFieldMask2 from "components/Inputs/LFieldMask/index copy";
import LAlert from "components/LAlert";

// interface FormCreditCardProps {
//   handleTokenize: (card: string) => void;
// }

const cardBrandsThatShouldShowError = {
  [EBrand.UNDEFINED]: "Cartão não encontrado!",
  [EBrand.UNSUPPORTED]: "Carrtão não suportado!",
};

const cardBrandsSuccess = [EBrand.AMERICANEXPRESS, EBrand.ELO, EBrand.HIPERCARD, EBrand.MASTER, EBrand.VISA];

export default function FormCreditCard() {
  const {selectedPlanContext, installmentsContext} = useLandingPageContext();
  const { values, errors, setFieldValue, touched, setFieldTouched } = useFormikContext();
  const [cardBrand, setCardBrand] = useState(null);

  const errorBrand =  cardBrand ? cardBrandsThatShouldShowError[cardBrand] : "";

  const handleIdentifyBrand = async (card: string) => {
    try {
      const brand = await identifyBrand(card);
      if(cardBrandsSuccess.includes(brand) && selectedPlanContext) {
        setFieldValue("brand", brand);
      }
      setCardBrand(brand);
      
    } catch (err) { 
      LAlert({description: `${err}`});
    }
  };

  return (
    <div className="flex-grow-1 d-flex gap-5 align-items-center">
      <div className="d-none d-md-flex">
        <CreditCard />
      </div>
      <div className="flex-grow-1 py-2">
        {/* Número do Cartão */}
        <LField
          label="Número do cartão"
          type="text"
          placeholder="0000 0000 0000 0000"
          maxLength={19}
          name="number"
          required
          value={getIn(values, "number")}
          onChange={(e) => {
            const value = e.target.value.replace(/\D/g, "");
            const formattedValue = value.replace(/(\d{4})(?=\d)/g, "$1 ").trim();
            setFieldValue("number", formattedValue);

            if (value.length === 16) {
              handleIdentifyBrand(value);
            } else {
              setCardBrand(null);
            }
          }}
          onBlur={() => setFieldTouched("number", true)}
          isInvalid={(!!getIn(touched, "number") && !!getIn(errors, "number")) || !!errorBrand}
          // isValid={!!cardBrand && cardBrandsSuccess.includes(cardBrand)}
          error={getIn(errors, "number") || errorBrand}
          className="mb-1"
        />

        <Row>
          {/* Validade (Mês e Ano) */}
          <Col>
            <LFieldMask2
              label="Validade (mm/aaaa)"
              type="text"
              placeholder="mm/aaaa"
              mask="99/9999"
              name="expiration"
              required
              value={getIn(values, "expiration")}
              onChange={(e) => {
                setFieldValue("expiration",  e.target.value);
              }}
              onBlur={() => setFieldTouched("expiration", true)}
              isInvalid={!!getIn(touched, "expiration") && !!getIn(errors, "expiration")}
              error={getIn(errors, "expiration")}
              className="mb-1"
            />
          </Col>

          {/* CVV */}
          <Col sm={4}>
            <LField
              label="CVV"
              type="text"
              placeholder="123"
              maxLength={3}
              name="cvv"
              required
              value={getIn(values, "cvv")}
              onChange={(e) => {
                const value = e.target.value.replace(/\D/g, "");
                setFieldValue("cvv", value);
              }}
              onBlur={() => setFieldTouched("cvv", true)}
              isInvalid={!!getIn(touched, "cvv") && !!getIn(errors, "cvv")}
              error={getIn(errors, "cvv")}
              className="mb-1"
            />
            
          </Col>
        </Row>

        <Row>
          <Col>
            <LField
              label="Nome do Titular"
              type="text"
              placeholder="Digite o nome do titular"
              name="holderName"
              required
              value={getIn(values, "holderName")}
              onChange={(e) => setFieldValue("holderName", e.target.value)}
              onBlur={() => setFieldTouched("holderName", true)}
              isInvalid={!!getIn(touched, "holderName") && !!getIn(errors, "holderName")}
              error={getIn(errors, "holderName")}
              className="mb-1"
            />
          </Col>
          <Col>
            <LFieldMask2
              label="CPF do Titular"
              type="text"
              placeholder="000.000.000-00"
              name="holderDocument"
              mask="999.999.999-99"
              required
              value={getIn(values, "holderDocument")}
              onChange={(e) => setFieldValue("holderDocument", e.target.value)}
              onBlur={() => setFieldTouched("holderDocument", true)}
              isInvalid={!!getIn(touched, "holderDocument") && !!getIn(errors, "holderDocument")}
              error={getIn(errors, "holderDocument")}
              className="mb-1"
            />
          </Col>
        </Row>

        <LSelect
          options={installmentsContext}
          label="Parcelamento"
          name="installmentsNumber"
          value={getIn(values, "installmentsNumber")}
          onChange={(e) => {
            setFieldValue("installmentsNumber",e.target.value ? Number(e.target.value) : "");
          }}
          onBlur={() => setFieldTouched("installmentsNumber", true)}
          required
          isInvalid={!!getIn(touched, "installmentsNumber") && !!getIn(errors, "installmentsNumber")}
          error={getIn(errors, "installmentsNumber")}
        />

      </div>
    </div>
  );
}
